export default __webpack_public_path__ + "static/media/Dr._Michele_Wright_AHV_In_Moms_We_Trust.506e84f7.jpg";